import { render, staticRenderFns } from "./modalAgregarLeecheros.vue?vue&type=template&id=79c8872f&"
import script from "./modalAgregarLeecheros.vue?vue&type=script&lang=js&"
export * from "./modalAgregarLeecheros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports